import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Teacher\BookingController::index
* @see app/Http/Controllers/Teacher/BookingController.php:17
* @route '/teacher/bookings'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/teacher/bookings',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Teacher\BookingController::index
* @see app/Http/Controllers/Teacher/BookingController.php:17
* @route '/teacher/bookings'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Teacher\BookingController::index
* @see app/Http/Controllers/Teacher/BookingController.php:17
* @route '/teacher/bookings'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Teacher\BookingController::index
* @see app/Http/Controllers/Teacher/BookingController.php:17
* @route '/teacher/bookings'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Teacher\BookingController::show
* @see app/Http/Controllers/Teacher/BookingController.php:39
* @route '/teacher/bookings/{booking}'
*/
export const show = (args: { booking: number | { id: number } } | [booking: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/teacher/bookings/{booking}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Teacher\BookingController::show
* @see app/Http/Controllers/Teacher/BookingController.php:39
* @route '/teacher/bookings/{booking}'
*/
show.url = (args: { booking: number | { id: number } } | [booking: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { booking: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { booking: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            booking: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        booking: typeof args.booking === 'object'
        ? args.booking.id
        : args.booking,
    }

    return show.definition.url
            .replace('{booking}', parsedArgs.booking.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Teacher\BookingController::show
* @see app/Http/Controllers/Teacher/BookingController.php:39
* @route '/teacher/bookings/{booking}'
*/
show.get = (args: { booking: number | { id: number } } | [booking: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Teacher\BookingController::show
* @see app/Http/Controllers/Teacher/BookingController.php:39
* @route '/teacher/bookings/{booking}'
*/
show.head = (args: { booking: number | { id: number } } | [booking: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Teacher\BookingController::confirm
* @see app/Http/Controllers/Teacher/BookingController.php:55
* @route '/teacher/bookings/{booking}/confirm'
*/
export const confirm = (args: { booking: number | { id: number } } | [booking: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: confirm.url(args, options),
    method: 'post',
})

confirm.definition = {
    methods: ["post"],
    url: '/teacher/bookings/{booking}/confirm',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Teacher\BookingController::confirm
* @see app/Http/Controllers/Teacher/BookingController.php:55
* @route '/teacher/bookings/{booking}/confirm'
*/
confirm.url = (args: { booking: number | { id: number } } | [booking: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { booking: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { booking: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            booking: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        booking: typeof args.booking === 'object'
        ? args.booking.id
        : args.booking,
    }

    return confirm.definition.url
            .replace('{booking}', parsedArgs.booking.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Teacher\BookingController::confirm
* @see app/Http/Controllers/Teacher/BookingController.php:55
* @route '/teacher/bookings/{booking}/confirm'
*/
confirm.post = (args: { booking: number | { id: number } } | [booking: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: confirm.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Teacher\BookingController::complete
* @see app/Http/Controllers/Teacher/BookingController.php:76
* @route '/teacher/bookings/{booking}/complete'
*/
export const complete = (args: { booking: number | { id: number } } | [booking: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: complete.url(args, options),
    method: 'post',
})

complete.definition = {
    methods: ["post"],
    url: '/teacher/bookings/{booking}/complete',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Teacher\BookingController::complete
* @see app/Http/Controllers/Teacher/BookingController.php:76
* @route '/teacher/bookings/{booking}/complete'
*/
complete.url = (args: { booking: number | { id: number } } | [booking: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { booking: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { booking: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            booking: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        booking: typeof args.booking === 'object'
        ? args.booking.id
        : args.booking,
    }

    return complete.definition.url
            .replace('{booking}', parsedArgs.booking.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Teacher\BookingController::complete
* @see app/Http/Controllers/Teacher/BookingController.php:76
* @route '/teacher/bookings/{booking}/complete'
*/
complete.post = (args: { booking: number | { id: number } } | [booking: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: complete.url(args, options),
    method: 'post',
})

const bookings = {
    index: Object.assign(index, index),
    show: Object.assign(show, show),
    confirm: Object.assign(confirm, confirm),
    complete: Object.assign(complete, complete),
}

export default bookings